import axios from "axios";
import apiConfig from "../config/apiConfig";

const quizApiInstance = axios.create({
  baseURL: apiConfig.endpoints.quizService.baseURL,
  timeout: 10000,
});

const getQuestions = async () => {
  try {
    const response = await quizApiInstance.get(apiConfig.endpoints.quizService.routes.getQuestions);
    return response.data ? response.data : response;
  } catch (error) {
    return error.data ? error.data : error;
  }
};

const createQuestions = async (queryParams) => {
  try {
    const response = await quizApiInstance.post(`${apiConfig.endpoints.quizService.routes.createQuiz}${queryParams}`);
    return response.data ? response.data : response;
  } catch (error) {
    return error.data ? error.data : error;
  }
};

const submit = async (body) => {
  try {
    const response = await quizApiInstance.post(apiConfig.endpoints.quizService.routes.submitQuiz, body);
    return response.data ? response.data : response;
  } catch (error) {
    return error.data ? error.data : error;
  }
};

const quizApi = {
  getQuestions,
  createQuestions,
  submit,
};

export default quizApi;